module.exports = __webpack_public_path__ + "img/icon-arrow-down-xs-blue.744fc361.svg";